module.exports = __webpack_public_path__ + "img/play.3f5e276e.svg";